export default __webpack_public_path__ + "static/media/angry.99cb4f18.png";